module.exports = __webpack_public_path__ + "static/media/digital-marketing-logo-medlink.bc8ddab6.png";